import { RefreshButton } from "../../../components/RefreshButton";
import { withPropsTransformer } from "../../../hocs";
const refreshButtonPropsTransformer = (inputProps) => {
    return inputProps.data;
};
export const ToolbarRefreshButton = withPropsTransformer(refreshButtonPropsTransformer)(RefreshButton);
//# sourceMappingURL=ToolbarRefreshButton.js.map